// supabase-js hides the JSON body of a failed edge-function call behind a generic
// "Edge Function returned a non-2xx status code". This reads the real reason back out of the response so a
// screen can show something a person can act on (for example the review-sandbox refusal).
//
//   const reason = await readEdgeError(error);            // real message, or error.message if there is none
//   if (isSandboxRefusal(reason)) ...
export async function readEdgeError(error, fallback) {
  try {
    const res = error && error.context;
    if (res && typeof res.clone === 'function') {
      const body = await res.clone().json();
      const msg = body && (body.error || body.message);
      if (typeof msg === 'string' && msg.trim()) return msg;
    }
  } catch (e) { /* the body was not JSON: fall through */ }
  return fallback || (error && error.message) || 'Something went wrong.';
}

// The wording every review-sandbox refusal starts with (src/lib/reviewerGuard.js and _shared/reviewerGuard.ts).
export const SANDBOX_REFUSAL_PREFIX = 'This is a review sandbox';
export const isSandboxRefusal = (text) => typeof text === 'string' && text.startsWith(SANDBOX_REFUSAL_PREFIX);

// Phone-number screens (Settings, the setup hub): the same wording everywhere. In the review sandbox the refusal is
// intentional, so say so plainly instead of the generic "non-2xx status code".
export const SANDBOX_PHONE_MESSAGE = "Buying and managing phone numbers isn't available in the review sandbox. In a real account you would pick and buy a number here.";
export async function phoneActionErrorText(error, prefix) {
  const reason = await readEdgeError(error);
  return isSandboxRefusal(reason) ? SANDBOX_PHONE_MESSAGE : prefix + reason;
}
